import { Utils } from 'choerodon-ui/dataset';
const isSame = Utils.isSame;
export default isSame;
